import {
  MultiSelect,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  useStateWithSetAction,
} from "@tellescope/ui";
import { cn } from "@tellescope/utils";
import { TellescopeFormFieldBaseProps } from "../types";
import { useTranslation } from "react-i18next";

export interface DropdownFieldProps extends TellescopeFormFieldBaseProps<"Dropdown"> {}

export const DropdownField = ({
  title,
  value = [],
  onChange,
  className,
  options,
  onBlur,
  error,
}: DropdownFieldProps) => {
  const { t } = useTranslation("forms");
  const [open, setOpen] = useStateWithSetAction(false, (isOpen) => {
    if (!isOpen) {
      onBlur?.();
    }
  });

  return (
    <div>
      {!!title && <h4>{title}</h4>}
      {options?.radio ? (
        <Select
          value={value[0]}
          onValueChange={(newVal) => {
            const newValue = [newVal];
            onChange(newValue);
          }}
          defaultOpen={false}
          open={open}
          onOpenChange={setOpen}
        >
          <SelectTrigger>
            {value[0] ? (
              <SelectValue className={cn(className, !!error && "border-destructive")}>{value[0]}</SelectValue>
            ) : (
              t("Select item...")
            )}
          </SelectTrigger>
          <SelectContent>
            {options?.optionDetails?.map((option) => (
              <SelectItem key={JSON.stringify(option)} value={option.option}>
                <div>
                  <p className={`${option.description ? "font-bold" : ""} text-sm`.trim()}>{option.option}</p>
                  {!!option.description && (
                    <p className="font-bold text-xs text-muted-foreground">{option.description}</p>
                  )}
                </div>
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      ) : (
        <MultiSelect
          value={value}
          onValueChange={(newVal) => {
            onChange(newVal);
          }}
          onBlur={onBlur}
          className={cn(className, !!error && "border-destructive")}
          options={
            options?.optionDetails?.map((option) => ({
              value: option.option,
              label: `${option.option} ${option.description ?? ""}`.trim(),
            })) ?? []
          }
          searchKeywords={(option) => [option.value, option.label]}
        />
      )}

      {!!error && <p className="text-sm text-destructive mt-1">{error}</p>}
    </div>
  );
};
